import {
  convertNumberToLocaleString,
  MetricSummaryWidgets,
  STATUSPAGE,
} from '@repo/ui';
import { PerformanceReportForProfessionalsSummary } from 'presentation/app/modules/Reports/models/performance-report-for-professionals';

interface IProps {
  loading: STATUSPAGE;
  summary: PerformanceReportForProfessionalsSummary;
}

export const PerformanceSummaryWidgets = ({ loading, summary }: IProps) => {
  return (
    <MetricSummaryWidgets
      iconLib="remix"
      loading={loading}
      data={[
        {
          label: 'Profissionais',
          counter: summary?.professionalsCount ?? 0,
          icon: {
            iconName: 'ri-user-3-line',
            size: 20,
            classNameColorIcon: '#3B82F6',
          },
        },
        {
          label: 'Atividades Finalizadas',
          counter: summary?.finishedActivitiesCount ?? 0,
          icon: {
            iconName: 'ri-checkbox-circle-line',
            size: 20,
            classNameColorIcon: '#22C55E',
          },
        },
        {
          label: 'Faltas Justificadas Validadas',
          counter: summary?.missedJustifiedValidatedActivitiesCount ?? 0,
          icon: {
            iconName: 'ri-close-circle-line',
            size: 20,
            classNameColorIcon: '#EF4444',
          },
        },
        {
          label: 'Média por Profissional',
          counter: convertNumberToLocaleString(
            Number(summary?.finishedActivitiesAvgPerProfessional || 0),
            {
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            }
          ),
          icon: {
            iconName: 'ri-line-chart-line',
            size: 20,
            classNameColorIcon: '#F59E0B',
          },
        },
        {
          label: 'Avaliações Realizadas',
          counter: summary?.evaluationsCount ?? 0,
          icon: {
            iconName: 'ri-star-line',
            size: 20,
            classNameColorIcon: '#8B5CF6',
          },
        },
      ]}
    />
  );
};
